import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { useDataModel } from '@thd-nucleus/data-sources';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { Etch as Etch2 } from './etch2/Etch2';
import { Etch as Etch1 } from './etch1/Etch1';
import { dataModel } from './dataModel';
import './etch-widgets.scss';

const EtchWidgets = (props) => {
  const { channel, store, clientStore } = useContext(ExperienceContext);
  const {
    dpdNewTab,
    keyword,
    navParam,
    content,
    showFavoritesCount,
    storeId,
    exclude,
    include,
    data: propData,
    loading: propLoading,
    error: propError,
    showDpdPod
  } = props;
  const { storeId: defaultStoreId } = clientStore || store;

  if (content) {
    const templates = [];
    try {
      templates.push(JSON.parse(content));
    } catch (err) {
      console.log('Failed to parse rich content');
    }
    const etch1Templates = templates && templates[0]?.Content ? templates : [];
    const etch2Templates = templates && templates[0]?.content ? templates : [];

    if (!(etch1Templates.length || etch2Templates.length)) {
      return null;
    }

    return (
      <div className="etch-widgets">
        <Etch2
          dpdNewTab={dpdNewTab}
          templates={etch2Templates}
          isCategory={false}
          channel={channel}
          storeId={storeId || defaultStoreId}
          keyword={keyword}
          navParam={navParam}
          showFavoritesCount={showFavoritesCount}
          exclude={exclude}
          include={include}
          showDpdPod={showDpdPod}
        />
        <Etch1
          dpdNewTab={dpdNewTab}
          templates={etch1Templates}
          isCategory={false}
          channel={channel}
          storeId={storeId || defaultStoreId}
          keyword={keyword}
          navParam={navParam}
          showFavoritesCount={showFavoritesCount}
          exclude={exclude}
          include={include}
          showDpdPod={showDpdPod}
        />
      </div>
    );
  }

  const searchResponse = useDataModel('searchModel', {
    skip: (propData || propLoading || propError),
    variables: {
      keyword,
      storeId: storeId || defaultStoreId,
      navParam
    }
  });

  let data;
  let loading;
  let error;

  if (propData || propLoading || propError) {
    data = propData;
    loading = propLoading;
    error = propError;
  } else {
    ({ data, loading, error } = searchResponse);
  }

  if (loading || !data) return null;

  // useEffect(() => { LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('etch-widgets.ready'); }, []);
  const { dimensions, relatedResults } = data?.searchModel || {};
  const stringifiedTemplates = data?.searchModel?.templates;
  const stringifiedPartialTemplates = data?.searchModel?.partialTemplates;
  let templates = [];
  let partialTemplates = [];
  try {
    templates = stringifiedTemplates?.map((template) => JSON.parse(template)) || [];
    partialTemplates = stringifiedPartialTemplates?.map((template) => JSON.parse(template)) || [];
  } catch (err) {
    console.log('Error parsing etch templates');
  }

  const etch1Templates = templates && templates[0]?.Content ? templates : [];
  const etch2Templates = templates && templates[0]?.content ? templates : [];

  if (!(etch1Templates.length || etch2Templates.length)) {
    return null;
  }

  return (
    <div className="etch-widgets">
      <Etch2
        dpdNewTab={dpdNewTab}
        templates={etch2Templates}
        isCategory={false}
        channel={channel}
        storeId={storeId || defaultStoreId}
        keyword={keyword}
        navParam={navParam}
        showFavoritesCount={showFavoritesCount}
        exclude={exclude}
        include={include}
        showDpdPod={showDpdPod}
      />
      <Etch1
        dpdNewTab={dpdNewTab}
        templates={etch1Templates}
        partialTemplates={partialTemplates}
        isCategory={false}
        channel={channel}
        storeId={storeId || defaultStoreId}
        keyword={keyword}
        navParam={navParam}
        showFavoritesCount={showFavoritesCount}
        exclude={exclude}
        include={include}
        showDpdPod={showDpdPod}
        dimensions={dimensions}
        relatedResults={relatedResults}
      />
    </div>
  );
};

EtchWidgets.displayName = 'EtchWidgets';

EtchWidgets.dataModel = dataModel;

EtchWidgets.propTypes = {
  keyword: PropTypes.string,
  storeId: PropTypes.string,
  navParam: PropTypes.string,
  content: PropTypes.string,
  showFavoritesCount: PropTypes.bool,
  exclude: PropTypes.arrayOf(PropTypes.string),
  include: PropTypes.arrayOf(PropTypes.string),
  data: PropTypes.shape({}),
  loading: PropTypes.bool,
  error: PropTypes.shape({}),
  showDpdPod: PropTypes.bool
};

EtchWidgets.defaultProps = {
  keyword: '',
  storeId: null,
  navParam: '',
  content: '',
  showFavoritesCount: false,
  exclude: [],
  include: [],
  data: undefined,
  loading: undefined,
  error: undefined,
  showDpdPod: false
};

export { EtchWidgets };
